import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';
import Swal from "sweetalert2";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, {encode: false});
    }
  };

  return axios.get(`${url}/workshop/workshop_service_estimates`, options)
    .then(response => {
      return {
        list: jsona.deserialize(response.data),
        meta: response.data.meta
      };
    });
}

function get(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };
  let apiRes = null;
  
  return axios.get(`${url}/workshop/workshop_service_estimates/${id}`, options)
    .catch(function (error) {
      // if (error.response) {
      //   // Request made and server responded
      //   console.log(error.response.data);
      //   console.log(error.response.status);
      //   console.log(error.response.headers);
      // } else if (error.request) {
      //   // The request was made but no response was received
      //   console.log(error.request);
      // } else {
      //   // Something happened in setting up the request that triggered an Error
      //   console.log('Error', error.message);
      // }
      if (error.response) {
        if(error.response.status = 404){
          // console.log("yahoo")
        }
        return false;
      }
      
    }).then(response => {
      if(response){
        // console.log(response)
      let service_estimates = jsona.deserialize(response.data);
      delete service_estimates.links;
      return service_estimates;
      }
    });
}

function add(service_estimates) {
  
  console.log(service_estimates);
  const payload = jsona.serialize({
    stuff: service_estimates,
    includeNames: null
  });
  console.log(payload);
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/workshop/workshop_service_estimates`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function update(service_estimates) {
  const payload = jsona.serialize({
    stuff: service_estimates,
    includeNames: []
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.patch(`${url}/workshop/workshop_service_estimates`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function update_status(service_estimates) {
  const payload = jsona.serialize({
    stuff: service_estimates,
    includeNames: []
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.patch(`${url}/workshop/workshop_service_estimates/update_status/${service_estimates.id}`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.delete(`${url}/workshop/workshop_service_estimates/${id}`, options);
}

function list_service(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/service_estimate_services?filter[service_estimate_service_estimate_id]=${id}`, options)
    .then(response => {
      console.log("terpanggil")
      let service = jsona.deserialize(response.data);
      delete service.links;
      return service;
    });
}

function list_part(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/service_estimate_spare_parts?filter[service_estimate_spare_part_estimate_id]=${id}`, options)
    .then(response => {
      let part = jsona.deserialize(response.data);
      delete part.links;
      return part;
    });
}

function list_ada_pkb(status) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/workshop/workshop_service_estimates?filter[service_estimate_pkb]=${status}`, options)
  .then(response => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta
    };
  });
}

function last_no() {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/workshop/workshop_service_estimates/last/no`, options)
    .then(response => {
      return response.data;
    });
}
 

export default {
  list,
  list_ada_pkb,
  get,
  add,
  update,
  update_status,
  destroy,
  list_service,
  list_part,
  last_no
};

